import { User, IdCard, Truck, History, UserCheck } from 'lucide-react';

export const STEP_IDS = ['personal', 'license', 'record', 'employment', 'review'];

export const STEPS = [
  { id: 'personal', title: 'Driver Information', shortTitle: 'Driver Info', icon: User, sections: ['personal', 'residences'] },
  { id: 'license', title: 'License & Experience', shortTitle: 'License', icon: IdCard, sections: ['licenses', 'experience'] },
  { id: 'record', title: 'Driving Record', shortTitle: 'Record', icon: Truck, sections: ['drivingRecord'] },
  { id: 'employment', title: 'Employment', shortTitle: 'Employment', icon: History, sections: ['employment'] },
  { id: 'review', title: 'Review & Sign', shortTitle: 'Finish', icon: UserCheck, sections: ['disclosures'] }
];

export const STEP_LABELS = Object.fromEntries(STEPS.map((step) => [step.id, step.title]));

export const stepIndex = (id) => STEP_IDS.indexOf(id);

export const APPLICATION_STATUS_LABELS = {
  invited: 'Invited',
  in_progress: 'In progress',
  submitted: 'Submitted',
  changes_requested: 'Changes requested',
  approved: 'Approved',
  hired: 'Hired',
  rejected: 'Not selected',
  withdrawn: 'Withdrawn',
  expired: 'Invite expired'
};

export const STATUS_BADGE_CLASSES = {
  invited: 'bg-gray-100 text-gray-700 border-gray-200',
  in_progress: 'bg-blue-50 text-blue-700 border-blue-200',
  submitted: 'bg-amber-50 text-amber-800 border-amber-200',
  changes_requested: 'bg-orange-50 text-orange-800 border-orange-200',
  approved: 'bg-green-50 text-green-800 border-green-200',
  hired: 'bg-emerald-100 text-emerald-900 border-emerald-200',
  rejected: 'bg-red-50 text-red-800 border-red-200',
  withdrawn: 'bg-gray-100 text-gray-600 border-gray-200',
  expired: 'bg-gray-100 text-gray-600 border-gray-200'
};

export const LICENSE_CLASS_OPTIONS = [
  { value: 'A', label: 'Class A (CDL)' },
  { value: 'B', label: 'Class B (CDL)' },
  { value: 'C', label: 'Class C (CDL)' },
  { value: 'non_cdl', label: 'Non-CDL (regular license)' }
];

export const ENDORSEMENT_OPTIONS = [
  { value: 'H', label: 'H - Placarded Hazmat' },
  { value: 'N', label: 'N - Tank Vehicles' },
  { value: 'P', label: 'P - Passengers' },
  { value: 'T', label: 'T - Double/Triple Trailers' },
  { value: 'S', label: 'S - School Bus' },
  { value: 'X', label: 'X - Tanker/Hazmat' }
];

export const EQUIPMENT_OPTIONS = [
  { value: 'straight_truck', label: 'Straight Truck' },
  { value: 'tractor_semi', label: 'Truck-Tractor / Semi-Trailer' },
  { value: 'tractor_doubles_triples', label: 'Doubles / Triples' },
  { value: 'flatbed', label: 'Flatbed' },
  { value: 'tanker', label: 'Tanker' },
  { value: 'bus', label: 'Bus' },
  { value: 'other', label: 'Other' }
];

export const RELATIONSHIP_OPTIONS = ['Spouse', 'Parent', 'Child', 'Sibling', 'Friend', 'Other'].map((value) => ({ value, label: value }));

export const POSITION_OPTIONS = [
  { value: 'company_driver', label: 'Company driver' },
  { value: 'owner_operator', label: 'Owner-operator' },
  { value: 'lease_purchase', label: 'Lease purchase' },
  { value: 'other', label: 'Other' }
];

export const DOCUMENT_SLOTS = [
  { slot: 'license_front', label: "Driver's license (front)", required: true, hint: 'Clear photo, all four corners visible' },
  { slot: 'license_back', label: "Driver's license (back)", required: true, hint: 'Endorsements and restrictions must be readable' },
  { slot: 'medical_card', label: "Medical examiner's certificate", required: true, hint: 'Your current DOT medical card' },
  { slot: 'twic_card', label: 'TWIC card', required: false, hint: 'Only if you have one', conditional: 'hasTwicCard' },
  { slot: 'passport', label: 'Passport', required: false, hint: 'Optional, photo page', conditional: 'hasPassport' },
  { slot: 'other', label: 'Other document', required: false, hint: 'Optional: long-form physical, training certificates, etc.', multiple: true }
];
